import React from "react";
import DogBreedData from "../../BreedData/DogBreeds.json";
import CatBreedData from "../../BreedData/CatBreeds.json";
import { useState, useEffect } from "react";
import { RadioGroup } from "@headlessui/react";
import { useTranslation } from "react-i18next";
import SearchableDropdown from "./SearchableDropdown";


const neutralOptions = [{ neutral: true }, { neutral: false }];

function PetGenderAndBreed({ petInfo, setPetInfo, setIsComplete, petType }) {
  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  const { t } = useTranslation();

  const genderOptions = [{ gender: t("male") }, { gender: t("female") }];

  const [selected, setSelected] = useState(petInfo.breed);
  const [gender, setGender] = useState();
  const [isNeutral, setIsNeutral] = useState();
  const [activator, setActivator] = useState(false);

  useEffect(() => {
    setActivator(true);
    if (activator) {
      setPetInfo({
        ...petInfo,
        breed: selected,
      });
    }
  }, [selected]);

  useEffect(() => {
    setActivator(true);
    if (activator) {
      setPetInfo({
        ...petInfo,
        gender: gender?.gender,
      });
    }
  }, [gender]);

  useEffect(() => {
    setActivator(true);
    if (activator) {
      setPetInfo({
        ...petInfo,
        isNeutral: isNeutral?.neutral,
      });
    }
  }, [isNeutral]);

  useEffect(() => {
    petInfo.breed && petInfo.gender && petInfo.isNeutral !== ""
      ? setIsComplete(true)
      : setIsComplete(false);
  }, [petInfo]);


  return (
    <div className="h-8/10 flex flex-col justify-center w-11/12 max-w-lg mt-6">
      <div className="m-6">
        <div className="flex items-center justify-between">
            <h2 className="font-poppins text-lg font-medium text-yellow-600">
              {petType=='dog' ? t("petBreed"): t("catPetBreed")}
            </h2>
        </div>
        <div className="mt-2">
          <SearchableDropdown
            options={petType === 'dog' ? DogBreedData : CatBreedData}
            label="name"
            id="id"
            selectedVal={selected}
            handleChange={(val) => setSelected(val)}
          />
        </div>

      </div>
      <div className="m-6">
        <div className="flex items-center justify-between">
          <h2 className="font-poppins text-lg font-medium text-yellow-600">
            {petType =='dog' ? t("petGender") : t("catPetGender")}
          </h2>
        </div>

        <RadioGroup value={gender} onChange={setGender} className="mt-2">
          <RadioGroup.Label className="sr-only">
            {petType =='dog' ? t("chooseGenderOption") : t("catChooseGenderOption")}
          </RadioGroup.Label>
          <div className="grid grid-cols-3 gap-3 sm:grid-cols-6">
            {genderOptions.map((option) => (
              <RadioGroup.Option
                key={option.gender}
                value={option}
                className={({ active, checked }) =>
                  classNames(
                    "cursor-pointer focus:outline-none",
                    active ? "ring-2 ring-offset-2 ring-lime-500" : "",
                    checked || petInfo.gender == option.gender
                      ? "bg-lime-600 border-transparent text-white hover:bg-lime-700"
                      : "bg-white border-yellow-200 text-yellow-800 hover:bg-yellow-50",
                    "border rounded-md py-3 px-3 flex items-center justify-center text-sm font-medium uppercase sm:flex-1"
                  )
                }
              >
                <RadioGroup.Label as="span">{option.gender}</RadioGroup.Label>
              </RadioGroup.Option>
            ))}
          </div>
        </RadioGroup>
      </div>
      <div className="m-6">
        <div className="flex items-center justify-between">
          <h2 className="font-poppins text-lg font-medium text-yellow-600">
            {petType == 'dog' ? t("isNeutered") : t("catIsNeutered")}
          </h2>
        </div>

        <RadioGroup value={isNeutral} onChange={setIsNeutral} className="mt-2">
          <RadioGroup.Label className="sr-only">
            Choose a memory option
          </RadioGroup.Label>
          <div className="grid grid-cols-3 gap-3 sm:grid-cols-6">
            {neutralOptions.map((option) => (
              <RadioGroup.Option
                key={option.neutral}
                value={option}
                className={({ active, checked }) =>
                  classNames(
                    "cursor-pointer focus:outline-none",

                    active ? "ring-2 ring-offset-2 ring-lime-500" : "",
                    checked || petInfo.isNeutral === option.neutral
                      ? "bg-lime-600 border-transparent text-white hover:bg-lime-700"
                      : "bg-white border-yellow-200 text-yellow-800 hover:bg-yellow-50",
                    "border rounded-md py-3 px-3 flex items-center justify-center text-sm font-medium uppercase sm:flex-1"
                  )
                }
              >
                <RadioGroup.Label as="span">
                  {option.neutral ? t("yes") : t("no")}
                </RadioGroup.Label>
              </RadioGroup.Option>
            ))}
          </div>
        </RadioGroup>
      </div>
    </div>
  );
}

export default PetGenderAndBreed;
